/**
 * Wartości oceny formalnej
 *
 * @export
 * @enum {number}
 */
export enum FormalAssessmentValue {
  PASSED = 1,
  NOT_APPLICABLE = 2,
  TO_FIX = 3,
  NOT_PASSED = 4
}

export const FormalAssessmentValueTranslations = {
  [FormalAssessmentValue.PASSED]: 'Tak',
  [FormalAssessmentValue.NOT_APPLICABLE]: 'Nie dotyczy',
  [FormalAssessmentValue.TO_FIX]: 'Do poprawy',
  [FormalAssessmentValue.NOT_PASSED]: 'Nie'
};

export const FormalAssessmentStatusTranslations = {
  [FormalAssessmentValue.PASSED]: 'Pozytywna',
  [FormalAssessmentValue.TO_FIX]: 'Do poprawy',
  [FormalAssessmentValue.NOT_PASSED]: 'Negatywna'
};
